// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"280":"mainThemeBlue","621":"mainThemeBurgundy"}[chunkId] || chunkId) + "." + {"248":"4b7d8562","280":"b9e231f3","424":"efed4b9b","621":"edcb5693","630":"c3b86f2d","691":"0762c382","719":"1a8ea769","776":"aa0f4372"}[chunkId] + ".chunk.js";
};